var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-wrapper"},[_c('div',{ref:"chart-0",staticClass:"single-chart",staticStyle:{"height":"280px"}}),_vm._v(" "),_c('div',{ref:"chart-1",staticClass:"single-chart",staticStyle:{"height":"280px"}}),_vm._v(" "),(_vm.labels == null)?_c('div',{staticClass:"single-chart"},[_c('Loading')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }